export default __webpack_public_path__ + "static/image3-f56f7fd82125e5dfefe9de335a790ad9.gif";